/** The tab icon: a Stinger from the game's own sprites, drawn at load (there are no image files). */

import { makeCanvas } from '../render/canvas';
import { atlasOf } from '../render/sprites';

export function installFavicon(): void {
  try {
    const a = atlasOf('stinger');
    const canvas = makeCanvas(32, 32);
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.imageSmoothingEnabled = false;
    // The upright frame, its 16 x 16 art doubled.
    const inset = (a.cellW - a.w) / 2;
    ctx.drawImage(a.canvas, inset, inset, a.w, a.h, 0, 0, 32, 32);
    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = canvas.toDataURL('image/png');
    document.head.append(link);
  } catch {
    // No icon is no loss.
  }
}
